import dayjs from 'dayjs';
import { ICandidate, ICandidateExperience, newMappingEntity } from 'wisestep-api';

import MonsterCandidates, { Education } from '../types/MonsterCandidates';
import MonsterResponse from '../types/MonsterResponse';

export const processMonsterResponse = (response: any): MonsterResponse => {
  let existing: any = null;
  const noresponse = false;
  const modifiedResponse: MonsterResponse = {
    candidates: [],
  };
  existing = [];

  const candidates = response.Monster.Resumes.Resume
    ? Array.isArray(response.Monster.Resumes.Resume)
      ? response.Monster.Resumes.Resume
      : [response.Monster.Resumes.Resume]
    : [];
  const candidatesResponse = buildCandidateRecords(candidates);
  modifiedResponse.candidates = candidatesResponse;
  modifiedResponse.noResponse = noresponse;
  modifiedResponse.existing = existing;
  return modifiedResponse;
};

function buildCandidateRecords(candidates: MonsterCandidates[]): MonsterCandidates[] {
  candidates.map((candidate) => {
    const candidateData: ICandidate = newMappingEntity();
    try {
      candidateData.totalYearsExperience = candidate.TotalYearsExperience;
      candidateData.name =
        candidate.PersonalData.Name.First && candidate.PersonalData.Name.Last
          ? `${candidate.PersonalData.Name.First} ${candidate.PersonalData.Name.Last}`
          : 'Candidate';
      candidateData.workAuthorization = candidate.WorkAuths
        ? candidate.WorkAuths.WorkAuth.Country?.__text
        : '';
      candidateData.candidateId = candidate._SID;
      candidateData.dateResumeLastUpdatedOnJobBoard = dayjs(candidate.DateModified._Date).format(
        'YYYY-MM-DD'
      );
      candidate.LastUpdated = candidateData.dateResumeLastUpdatedOnJobBoard;
      candidateData.currentSalary = 0;
      candidateData.source = 'MONSTERUS';
      if (candidate.Relevance) {
        const relevancePercentage = Number(candidate.Relevance) * 100;
        candidateData.relevance = parseFloat(relevancePercentage.toFixed(2)).toString() + '%';
      }
      const candidatesSkills = candidate.Skills?.Skill
        ? Array.isArray(candidate.Skills?.Skill)
          ? candidate.Skills?.Skill
          : [candidate.Skills?.Skill]
        : [];
      const skills = candidatesSkills?.map((skill) =>
        typeof skill.Name !== 'string' ? skill.Name.__text : skill.Name
      );
      candidateData.skills = skills ?? [];
      candidate.candidateData = candidateData;
      const location = candidate.PersonalData.Address.Location;
      const locationSplit = location ? location.split('-') : [];
      const country = locationSplit[0];
      const state = locationSplit.length > 1 ? locationSplit[1] : '';
      candidate.candidateData.currentLocation = {
        countryCode: country,
        country: country,
        state: state,
        stateCode: state,
        continent: '',
        continentCode: '',
        city: candidate.PersonalData.Address.City,
        zipCode: candidate.PersonalData.Address.PostalCode,
      };
      let experience: any = candidate.Experiences?.Experience;
      if (Array.isArray(experience) && experience.length > 1) {
        getCandidateExperience(experience, candidate.candidateData);
        candidate.candidateData.previousEmployers = experience.map(
          (data) => data.Company?.Name?.__text ?? data.Company?.Name
        );
        candidate.candidateData.previousJobTitles = experience.map(
          (data) => data?.Job?.Title?.__text ?? data?.Job?.Title
        );
        experience = experience[0];
      }
      if (experience) {
        candidate.candidateData.currentJobTitle =
          experience.Job?.Title?.__text ?? experience.Job?.Title;
        candidate.candidateData.currentEmployer =
          experience.Company?.Name?.__text ?? experience.Company?.Name;
      }
      let education: any = candidate.Educations?.Education;
      if (Array.isArray(education) && education.length > 1) {
        education = education[0];
      }
      candidate.HighestEducation = education?.Level?.__text;

      const candidateEducation: Education | Education[] = candidate.Educations?.Education;
      const institutesAttended: string[] = [];

      if (Array.isArray(candidateEducation)) {
        for (let i = 0; i < candidateEducation.length; i++) {
          institutesAttended.push(candidateEducation[i].School?.Name ?? '');
        }
      } else {
        institutesAttended.push(candidateEducation?.School?.Name ?? '');
      }
      candidateData.institutionsAttended = institutesAttended;
      candidateData.hasVeteranStatus = candidate.VeteranStatus == 1 ? true : false;
    } catch (e) {
      console.log(e);
    }
  });
  return candidates;
}

const getCandidateExperience = (experience: any, candidate: ICandidate) => {
  const historyData = experience.map((data) => {
    const history: ICandidateExperience = {
      org: data.Company?.Name?.__text ?? data.Company?.Name ?? '',
      periodEnd: {
        year: data.DateTo?._Year ?? 0,
        month: data.DateTo?._Month ?? 0,
        day: 0,
      },
      periodStart: {
        year: data.DateFrom?._Year ?? 0,
        month: data.DateFrom?._Month ?? 0,
        day: 0,
      },
      title: data?.Job?.Title?.__text ?? data?.Job?.Title ?? '',
    };
    return history;
  });
  candidate.experience = {
    current: historyData[0],
    history: historyData,
  };
};
